import React, {useEffect} from "react";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import PropTypes from "prop-types";
import {Calendar} from "primereact/calendar";
import {Dropdown} from "primereact/dropdown";

/**
 * Simple filter form used by "Акт сверки АВР (Юр лица)".
 * Props:
 * - filterParam: current query object
 * - setFilterParam: setter function for query
 * - onSubmit: submit handler (e) => { ... }
 * - onClear: clear/reset handler (e) => { ... }
 */
const AvrPhysFilter = ({ filterParam, setFilterParam, onSubmit, onClear }) => {
    const returnedOptions = [
        {id: "all", value: 'Все'}, {id: "yes", value: "Да"}, {id: "no", value: "Нет"}
    ]
    // Ensure default value is set once on mount to avoid state updates during render
    useEffect(() => {
        if (!filterParam?.returned) {
            setFilterParam({ ...filterParam, returned: "all" });
        }
    }, []);
    return (
        <form onSubmit={onSubmit}>
            <div className="p-fluid p-formgrid p-grid">
                <div className="p-field p-col-6 p-md-3">
                    <label htmlFor="user">Телефон/ФИО/ИИН</label>
                    <InputText
                        id="user"
                        name="q"
                        value={filterParam.q || ""}
                        onChange={(e) => setFilterParam({ ...filterParam, q: e.target.value })}
                    />
                </div>
            </div>
            <div className="p-fluid p-formgrid p-grid">
                <div className="p-field p-col-6 p-md-3">
                    <label htmlFor="transactionId">Номер транзакции</label>
                    <InputText
                        id="transactionId"
                        name="transactionId"
                        value={filterParam.transactionId || ""}
                        onChange={(e) => setFilterParam({ ...filterParam, transactionId: e.target.value })}/>
                </div>
                <div className="p-field p-col-6 p-md-3">
                    <label htmlFor="returned">Возврат да/нет</label>
                    <Dropdown
                        inputId="returned"
                        name="returned"
                        value={ filterParam.returned }
                        options={returnedOptions}
                        optionLabel="value"
                        optionValue="id"
                        placeholder="Возврат да/нет"
                        showClear
                        onChange={(e) => setFilterParam({ ...filterParam, returned: e.value ?? "all" })}
                    />
                </div>
                <div className="p-field p-col-6 p-md-3">
                    <label htmlFor="startDate">Дата начала</label>
                    <Calendar id="startDate" inputId="startDate" name="startDate" value={filterParam.startDate}
                              onChange={(e) => setFilterParam({ ...filterParam, startDate: e.value })}
                              locale="ru"
                              showIcon
                              showButtonBar
                              onClearButtonClick={() => setFilterParam({ ...filterParam, startDate: null })}
                    />
                </div>
                <div className="p-field p-col-6 p-md-3">
                    <label htmlFor="endDate">Дата конца</label>
                    <Calendar id="endDate" inputId="endDate" name="endDate" value={filterParam.endDate}
                              onChange={(e) => setFilterParam({ ...filterParam, endDate: e.value })}
                              locale="ru"
                              showIcon
                              showButtonBar
                              onClearButtonClick={() => setFilterParam({ ...filterParam, endDate: null })}
                    />
                </div>
            </div>
            <div className="p-grid p-justify-end">
                <div className="p-mr-2">
                    <Button type="submit" label="Найти" />
                </div>
                <div className="p-mr-2">
                    <Button className="p-button-warning" label="Сбросить" onClick={onClear} />
                </div>
            </div>
        </form>
    );
};

AvrPhysFilter.propTypes = {
    filterParam: PropTypes.object.isRequired,
    setFilterParam: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    onClear: PropTypes.func.isRequired,
};

export default AvrPhysFilter;